<template>
  <v-snackbar
    v-model="notification.snackbar"
    :color="notification.color"
    :bottom="notification.y === 'bottom'"
    :left="notification.x === 'left'"
    :multi-line="notification.mode === 'multi-line'"
    :right="notification.x === 'right'"
    :timeout="notification.timeout"
    :top="notification.y === 'top'"
    :vertical="notification.mode === 'vertical'"
  >
    {{ notification.text }}
    <v-btn color="#ffffff" flat @click="notification.snackbar = false">
      <v-icon>clear</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["notification"])
  },
  data() {
    return {
      notification2: {
        snackbar: false,
        y: "bottom",
        x: null,
        color: "#00aeef",
        mode: "",
        timeout: 3000,
        message: ""
      }
    };
  },
  methods: {
    show(message, color = "#00aeef", y = "bottom") {
      this.notification.text = message;
      this.notification.color = color;
      this.notification.y = y;
      this.notification.snackbar = true;
    }
  }
};
</script>
